import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import ApiDashboard from "../../../app/api/admin/dashboard/ApiDashboard";
import Page from "../../modules/page";
import { ContextContent } from "../../modules/content/contentContext";
import Loader from "../../components/loader";
import "./styles.css";

// Дашборд: сводные счётчики фермы (GET authorized/admin/dashboard).
export default function DashboardIndex({ ...other }) {
    return <Page {...other}>
        <DashboardIndexContent/>
    </Page>;
}

function DashboardIndexContent() {
    const contextContent = useContext(ContextContent);
    const [summary, setSummary] = useState(null);

    useLayoutEffect(() => {
        contextContent.setTitle('Панель управления');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let isActual = true;
        (async () => {
            const api = ApiDashboard.Index();
            const data = await api.getResponse();
            if (isActual && data !== null) setSummary(data);
        })();
        return () => { isActual = false; };
    }, []);

    if (summary === null) return <Loader text="Загрузка сводки…"/>;

    return <div className="dashboard">
        <div className="dashboard__cards">
            <div className="dashboard__card">
                <div className="dashboard__card-label">Ноды</div>
                <div className="dashboard__card-value">{summary.nodes_count ?? 0}</div>
            </div>
            <div className="dashboard__card">
                <div className="dashboard__card-label">Устройства</div>
                <div className="dashboard__card-value">{summary.devices_count ?? 0}</div>
            </div>
            <div className="dashboard__card">
                <div className="dashboard__card-label">Онлайн</div>
                <div className="dashboard__card-value dashboard__card-value_online">{summary.online_count ?? 0}</div>
            </div>
        </div>
    </div>;
}
